import { Injectable, signal } from '@angular/core'
import { RootInjectorGuard } from '../guards/root-injector.guard'

@Injectable({
  providedIn: 'root',
})
export class SpinnerService extends RootInjectorGuard {
  public isRequesting = signal(false)
  constructor() {
    super(SpinnerService)
  }

  startSpinner() {
    this.isRequesting.set(true)
  }

  stopSpinner() {
    this.isRequesting.set(false)
  }
}
